import React, { useEffect } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { api } from "../../../services/api";
import ym from "react-yandex-metrika";

export function DefaultFlow({ transactionData, onRequirePersonalInfo }) {

    async function startTransaction() {

        const body = {
            username: transactionData.username,
            server: transactionData.server,
            gateway: transactionData.gateway,
            currencyCode: transactionData.currencyCode,
            token: transactionData.token,
            utm_source: transactionData.utm_source,
            utm_medium: transactionData.utm_medium,
            utm_campaign: transactionData.utm_campaign,
            items: transactionData.items,
        }

        const isInIFrame = window.location !== window.parent.location;

        try {
            let response = await api.post("payment/purchase", body);

            if (response.data.status === "fail") {
                // Conta sem os dados pessoais obrigatórios (ex.: telefone): volta para o formulário.
                if (response.data.message === "missing-personal-info" && onRequirePersonalInfo) {
                    onRequirePersonalInfo();
                    return;
                }
                const cached = JSON.parse(localStorage.getItem('startParams') || '{}');
                window.location = `/?username=${encodeURIComponent(cached.username || '')}&lang=${encodeURIComponent(cached.lang || '')}`;
                return;
            }

            ym("reachGoal", "purchase_request");

            if (transactionData.gateway === "fastspring") {
                window.open(
                    "https://raidhut.onfastspring.com/embedded-store/session/" +
                    response.data.session_id,
                    isInIFrame ? "_self" : "_parent"
                );
            } else if (transactionData.gateway === "paymentwall") {
                window.open(response.data.secure_url, isInIFrame ? "_self" : "_parent");
            } else if (transactionData.gateway === "paypal") {
                if (response.data.paypalOrderId) {
                    sessionStorage.setItem("paypalOrderId", response.data.paypalOrderId);
                }
                // PayPal blocks iframe embedding via CSP frame-ancestors, so always open in _parent/_top
                window.open(response.data.approvalUrl, isInIFrame ? "_top" : "_parent");
            } else if (transactionData.gateway === "xsolla") {
                if (response.data.xsollaOrderId) {
                    sessionStorage.setItem("xsollaOrderId", response.data.xsollaOrderId);
                }
                window.open(response.data.approvalUrl, isInIFrame ? "_top" : "_parent");
            }
        } catch (error) {
            console.error("Error:", error);
        }
    }

    useEffect(() => {
        startTransaction();
    }, []);

    return (
        <div className="spinner-div">
            <ProgressSpinner />
        </div>
    )
}